// date key and separator character checks
export const validSeparatorsRegex = /[-.\/]/ // matches "-", ".", "/"

// error messages for invalid dates
export const defaultErrorMessages: Record<DateErrorType, string> = {
	date: 'Date must be in the format MM/DD/YYYY',
	day: 'Day is invalid',
	hidden: '',
	max: 'This date is too far in the future',
	min: 'This date is too far in the past',
	month: 'Month is invalid',
	year: 'Year is invalid',
}

export type DateErrorType =
	| 'date'
	| 'day'
	| 'hidden'
	| 'max'
	| 'min'
	| 'month'
	| 'year'
